// start:ng42.barrel
export * from './hotel-image.component';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/hotel-image/index.ts